import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  urlLocal = 'documentos/' + localStorage.getItem('userName'); // documentos/gbarreiro
  constructor(private http: HttpClient,
              private _commom: CommonService,
              private _util: UtilsService) {
  }

  getAll() {
    return this._commom.peticionGetConHeader(this._util.getSustentos() + this.urlLocal);
  }

  actualizarOrden(objetoFactura) {
    return this._commom.peticionPutConHeader(this._util.getSustentos() + 'documentos', objetoFactura);
  }


  getParametro(fechaInicial, fechaFinal, ctrStatusDoc) {
    return this._commom.peticionGetConHeader(this._util.getSustentos() + this.urlLocal + '?fechaInicial=' + fechaInicial +
      '&fechaFinal=' + fechaFinal +
      '&status=' + ctrStatusDoc);
  }

}
